const sections = [
  { href: "#quotes", label: "精选语录" },
  { href: "#lines", label: "治愈短句" },
  { href: "#reflections", label: "时光感悟" },
  { href: "#companion", label: "深夜陪伴" },
];

const more = [
  { href: "#captions", label: "朋友圈配文" },
  { href: "#wall", label: "共鸣墙" },
  { href: "#faq", label: "常见问题" },
  { href: "#top", label: "回到顶部" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-moon-clear-line text-base"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">长日光阴</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 max-w-md">
              一个关于伤感文案、心情语录与治愈系短句的中文页面。我们相信伤感不必被放大，
              温柔克制的文字，也能陪你把漫长的光阴慢慢走完。
            </p>
            <p className="mt-4 text-xs text-foreground-600">
              所有内容为情绪表达与文学性文字，不构成任何专业建议。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">内容导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {sections.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">更多</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {more.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 长日光阴 · 愿你被这个世界温柔以待</p>
          <p className="text-xs text-foreground-600 flex items-center gap-1.5">
            <i className="ri-sun-line"></i>
            长日光阴，慢慢来，不着急
          </p>
        </div>
      </div>
    </footer>
  );
}